module.exports = __webpack_public_path__ + "static/falcon-booster-raw-ce293c7e64ebd9c279519940aa9a3ec4.png";